import type { ICheckboxInput } from '../types';
import * as s from './styles/checkbox.module.css';

const Checkbox = ({ id, className, label, backgroundColor = 'dark', size = 'medium', disabled = 'enabled', ...props }: ICheckboxInput) => {
  return (
    <div className={`${s.checkbox} ${s[backgroundColor]} ${s[disabled]} ${s[size]}`}>
      <div className={s.checkboxContainer}>
        <input type="checkbox" id={id} disabled={disabled === 'disabled' ? true : false} {...props} />
        <label className={s.checkboxLabel} htmlFor={id}></label>
        <label className={className} htmlFor={id}>{label}</label>
      </div>
    </div>
  );
};

export default Checkbox;
